import React, { useEffect, useState } from 'react'
import zoomIcon from '../../../assets/images/zoom-icon.png'
import emptyavatar from '../../../assets/images/emptyavatar.webp'
import exclamationOrange from '../../../assets/images/exclamation-orange.png'
import { useSelector } from 'react-redux'
// import moment from 'moment';
import moment from 'moment-timezone';
import { ToastContainer, toast } from 'react-toastify';
import VideoJoinModal from '../Chat/Modals/VideoJoinModal';
import api from '../../../services/api';
import { timeDifferenceCalculator } from 'time-difference-calculator';
import ReactTimeAgo from 'react-time-ago'
import FeedbackCoach from '../../Client/FindTherapist/Popups/FeedbackCoach';
import ReportModal from '../Chat/Modals/ReportModal'
import { BASE_URL } from '../../../keys'
import { useUpdateBookingStatusMutation } from '../../../services/coachApi'

const NotesHeader = (selectedClientDetails) => {

    // console.log('selectedClientDetails from NotesHeader', selectedClientDetails)

    const [barStyle, setbarStyle] = useState("")
    const [countDown, setcountDown] = useState(null)
    const [videoModal, setvideoModal] = useState(false)
    const [videoLink, setvideoLink] = useState(null)
    const [feedback, setfeedback] = useState(false)
    const [modalDisplay, setModalDisplay] = useState(false)
    const [flaggedStatus, setFlaggedStatus] = useState("")
    const currentChatUser = useSelector(state => state.chatUserReducer.user)
     const [updateBookingStatus] = useUpdateBookingStatusMutation();
const deviceTimezone = localStorage.getItem('device_timezone')
 const userDetails=useSelector(state=>state.userReducer)
//  console.log(userDetails);
 
    const userTimezone = userDetails?.user?.data?.timezone?.name || deviceTimezone;
    // console.log('currentChatUser from NotesHeader', currentChatUser);
 const getUserTime = (date, time) => {
    if (!date || !time) return null;
    
    const utcDateTime = `${date}T${time}:00Z`; // e.g., '2025-08-06T10:20:00Z'
    return moment.utc(utcDateTime).tz(userTimezone);
    };
    useEffect(() => {
        if (countDown?.days > 0) {
            return setbarStyle(`${100 / countDown.days}%`)
        } else if (countDown?.hour > 0) {
            return setbarStyle(`${100 / countDown.hour}%`)
        } else if (countDown?.days === 0) {
            return setbarStyle("100%")
        }
    }, [currentChatUser, countDown])
    const convertToUserTimezone = (date, time, timezone) => {
      if (!date || !time || !timezone) return null;
    
      try {
        const utcTime = moment.utc(`${date} ${time}`, 'YYYY-MM-DD HH:mm');
        return utcTime.tz(timezone);
      } catch (err) {
        // console.error("Timezone conversion error:", err);
        return null;
      }
    };
    let sessionDurationMinutes = 60;
const handleVideoCall = async () => {
  console.log("click");

  if (
    !currentChatUser?.session_date ||
    !currentChatUser?.session_time
  ) {
    toast.warn("Session details not available");
    return;
  }

  const sessionMoment = convertToUserTimezone(
    currentChatUser.session_date,
    currentChatUser.session_time,
    userTimezone
  );

//   console.log(sessionMoment);

  if (!sessionMoment || !moment.isMoment(sessionMoment)) {
    toast.warn("Invalid session time");
    return;
  }

  const now = moment();

  // NOW - SESSION_START (in minutes)
  const diffInMinutes = now.diff(sessionMoment, "minutes");
//   console.log(diffInMinutes);

  //  Session not started
  if (diffInMinutes < 0) {
    toast.warn("Your session has not started yet!");
    return;
  }

  //  Session expired
  if (diffInMinutes > sessionDurationMinutes) {
    toast.warn("Your session is already completed!");
    return;
  }

  
  try {
    const res = await api.get(
      `common/get-booking-link/${currentChatUser?.last_message?.booking_id}`,
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem("livtoken")}`,
        },
      }
    );
 localStorage.setItem("client_name", currentChatUser?.user_name);
    setvideoLink(res.data.data.zoom_link);
    setvideoModal(true);
// console.log(currentChatUser.user_id);

    const formData = new FormData();
    formData.append("person_id", currentChatUser.user_id);
    formData.append("booking_id", currentChatUser.last_message.booking_id);

   

    await updateBookingStatus(formData);

  } catch (err) {
    const apiError = err?.response?.data;
// console.log(apiError);

    if (
      apiError?.data?.error?.[0] ===
      "Please give previous session a rating."
    ) {
      // extract booking_id & user_id
      const prevBookingId = apiError?.data_key?.[0]?.[0];
      const prevUserId = apiError?.data_key?.[0]?.[1];
// console.log(prevBookingId,prevUserId);

      setfeedback({
        booking_id: prevBookingId,
        user_id: prevUserId,
      });

      return;
    }

    // console.error(err);
  }
};



    



    const feedbackModal = () => {
        setTimeout(() => {
            setfeedback(true)
        }, 5000);
    }

    const feedbackClose = () => {
        setfeedback(false);
    }


    const DateTimeCal = (dateTime) => {

        const eventDate = Date.parse(dateTime);
        const eventCountdown = setInterval(() => {

            const now = new Date().getTime()
            const daysDivider = 1000 * 60 * 60 * 24
            const hourDivider = 1000 * 60 * 60
            const minutesDivider = 1000 * 60
            const secondsDivider = 1000


            const d = Math.floor(eventDate / daysDivider - now / daysDivider)
            const h = Math.floor((eventDate / hourDivider - now / hourDivider) % 24)
            const m = Math.floor((eventDate / minutesDivider - now / minutesDivider) % 60)
            const s = Math.floor((eventDate / secondsDivider - now / secondsDivider) % 60)

            const diff = eventDate - now
            if (diff > 0) {
                const countDownTemp = {
                    days: d,
                    hour: h,
                    minute: m,
                    second: s
                }
                setcountDown(countDownTemp)
                if (d > 0) {
                    return clearInterval(eventCountdown)
                }
                if (h > 0) {
                    return clearInterval(eventCountdown)
                }
                //console.log(`${d} Days  ${h} Hour ${m} Minute ${s} Seconds`)
            } else {
                // console.log("session completed")
                const countDownTemp = {
                    days: 0,
                    hour: 0,
                    minute: 0,
                    second: 0
                }
                setcountDown(countDownTemp)
                clearInterval(eventCountdown)
            }

        }, 1000)
    }

    return (
        <div className="flex border-b border-[#FFDBB0] pb-6 items-center">
            <div className="overflow-hidden flex justify-center items-center border w-[55px] h-[55px] rounded-full bg-[#FDE9D8] border-[#FFDBB0] ">
                {typeof selectedClientDetails?.selectedClientDetails !== 'undefined' ?
                    <img
                        src={`${selectedClientDetails?.selectedClientDetails?.user_profile_pic}` !== '' ?
                            `${BASE_URL}${selectedClientDetails?.selectedClientDetails?.user_profile_pic}` :
                            `${emptyavatar}`} onError={(e) => {
    e.currentTarget.src = emptyavatar;}}
                        alt="profile image"
                        className=" w-[55px] h-[55px] rounded-full object-cover"
                    /> :
                    <img
                        src={`${emptyavatar}`}
                        alt="profile image"
                        className="w-[55px] h-[55px] rounded-full object-cover"
                    />
                }
            </div>
            <p className="w-[150px] pl-4  font-semibold text-base">
                {selectedClientDetails?.selectedClientDetails?.user_name}
            </p>
 <div className="flex font-ubuntu bg-[#FFDBB0] rounded-[40px] w-max xl:ml-16 h-8 items-center">
             <div className="bg-white overflow-hidden rounded-2xl h-2 w-12 xl:w-12 my-auto ml-4 relative">
                <div style={{ width: barStyle }} className="absolute bg-orange h-full top-0 left-0" />
            </div>
            <p className="flex-1 font-normal text-[8px] xl:text-[13px] mx-3">  
                 {
                        selectedClientDetails?.selectedClientDetails?.session_date ?
                            // <ReactTimeAgo date={selectedClientDetails?.selectedClientDetails?.session_date + " " + selectedClientDetails?.selectedClientDetails?.session_time} locale="en-US" />
                           <ReactTimeAgo 
                                  date={getUserTime(selectedClientDetails?.selectedClientDetails?.session_date, selectedClientDetails?.selectedClientDetails?.session_time).toDate()}/>
                            : null
                    }</p>
                         <div className="flex-none cursor-pointer" onClick={handleVideoCall}>
                        <img src={zoomIcon} alt="" className="border-[#FFFFFF] w-[25px] h-[25px] border-[2px] rounded-3xl" />
                    </div>
        </div>
            

            {/* <div className="pt-4 ml-14">
                <div className="bg-[#FFFFFF] w-[30px] rounded-[5px]">
                    <img onClick={() => setModalDisplay(true)} src={exclamationOrange} alt="" className="h-6 cursor-pointer" />
                </div>
            </div> */}

            {modalDisplay &&
                <ReportModal
                    currentChatUser={currentChatUser}
                    userFlaggedStatus={flaggedStatus}
                    onCloseModal={() => setModalDisplay(false)}
                />
            }
            {
                videoModal &&
                <VideoJoinModal feedbackModal={feedbackModal} onCloseModal={() => setvideoModal(false)} videoLink={videoLink} currentChatUser={currentChatUser} />
            }
            {
                feedback &&
                <FeedbackCoach feedbackClose={feedbackClose} booking_id={feedback.booking_id}
                        user_id={feedback.user_id}/>
            }
        </div>
    )
}

export default NotesHeader